import { render, staticRenderFns } from "./sort_fields.vue?vue&type=template&id=0563fc14&"
import script from "./sort_fields.vue?vue&type=script&lang=js&"
export * from "./sort_fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports